/* CustomSolo — size / variant picker
   ------------------------------------------------------------------------
   Renders a pill group for the product's Size option and keeps three things
   in sync when a size is picked:

     1. the hidden  name="id"  input  — this is what the cart actually reads
     2. the price line in the purchase block
     3. a `variant:change` event, so app blocks (CustoMeow) that bind their
        customizer at variant level get a chance to react

   Deliberately dumb about money: prices arrive pre-formatted from Liquid
   (variant.price | money) and are only swapped as strings. No parsing, no
   re-formatting, no currency assumptions.

   Scope: [data-cs-size-picker] only. Nothing outside it is touched.
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function announce(root, opt) {
    /* Let app blocks that bind per-variant know the selection moved. */
    var payload = {
      id: opt.getAttribute('data-variant-id'),
      option: opt.getAttribute('data-option-value'),
      price: opt.getAttribute('data-price-text') || '',
      sku: opt.getAttribute('data-sku') || '',
      available: opt.getAttribute('data-available') !== 'false',
      element: opt,
    };
    ['variant:change', 'cs:variant:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { detail: payload, bubbles: true }));
    });
    root.setAttribute('data-cs-size-current', payload.option || '');
  }

  function bindPicker(root) {
    var opts = root.querySelectorAll('[data-cs-size-opt]');
    if (!opts.length) return;

    var hidden = document.querySelector('[data-cs-variant-id]');
    var priceEl = document.querySelector('[data-cs-price]');
    var valueEl = root.querySelector('[data-cs-size-value]');

    Array.prototype.forEach.call(opts, function (opt) {
      if (opt.disabled) return;
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(opts, function (o) {
          var on = o === opt;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (hidden) hidden.value = opt.getAttribute('data-variant-id');
        if (priceEl && opt.getAttribute('data-price-text')) {
          priceEl.textContent = opt.getAttribute('data-price-text');
        }
        if (valueEl) valueEl.textContent = opt.getAttribute('data-option-value') || '';

        announce(root, opt);
      });
    });
  }

  onReady(function () {
    var pickers = document.querySelectorAll('[data-cs-size-picker]');
    Array.prototype.forEach.call(pickers, function (root) { bindPicker(root); });
  });
})();
